import { useContext } from 'react'
import { useLocation } from 'react-use'
import { hooks } from '@digital-commerce/shared-utils'
import localeContext from '../contexts/Locale'

import useCart from './useCart'
import useAuthentication from './useAuthentication'
import useFeatureFlags from './useFeatureFlags'

const defaultSideEffect = (analyticEvent) => {
  window.dataLayer = analyticEvent
}

const useLegacyAnalytics = (sideEffect = defaultSideEffect) => {
  const { cart } = useCart()
  const location = useLocation()
  const isAuthenticated = useAuthentication()
  const { isIrpcFlow } = hooks.useIRPCParams()
  const { lang, prov } = useContext(localeContext)
  const { data: featureFlags } = useFeatureFlags()
  const userUUID = localStorage?.getItem('uuid') ?? ''

  /*
   * Update window.dataLayer object
   * @example
   * useLegacyAnalytics(({ cart, lang, prov }) => {...})
   */
  const updateLegacyDataLayer = (createEvent) => {
    if (typeof createEvent !== 'function') {
      // eslint-disable-next-line no-console
      console.error('Invalid analytics event creator function')
      return
    }
    const analyticEvent = createEvent({
      cart,
      featureFlags,
      lang,
      prov,
      location,
      isAuthenticated,
      isIrpcFlow,
      userUUID
    })
    sideEffect(analyticEvent)
  }

  return {
    updateLegacyDataLayer
  }
}

export default useLegacyAnalytics
